var map = {
	"./Badges.address.js": 272,
	"./BuffiDai.address.js": 273,
	"./Burner.address.js": 274,
	"./BurnerVendor.address.js": 275,
	"./DenDai.address.js": 276,
	"./ENS.address.js": 187,
	"./ERC20Vendable.address.js": 277,
	"./Emitter.address.js": 188,
	"./Exchange.address.js": 278,
	"./Links.address.js": 279,
	"./StableCoin.address.js": 280,
	"./VendingMachine.address.js": 281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 446;